import { z } from "zod";
import { Id } from "./common";
import { defineRoutes } from "./define";
import { PROBLEMS } from "./problem";

export const PATIENT_PACKAGE_STATUSES = ["active", "exhausted", "cancelled"] as const;
export const PatientPackageStatus = z.enum(PATIENT_PACKAGE_STATUSES);

export const SellPackageBody = z.object({ packageDefId: Id });
export type SellPackageBody = z.infer<typeof SellPackageBody>;

export const PackageSold = z.object({ patientPackageId: Id });
export type PackageSold = z.infer<typeof PackageSold>;

export const PackageCancelled = z.object({ ok: z.literal(true), patientId: Id });

/** Sold package instances (definitions live under /pricing). */
export const packages = defineRoutes({
  sell: {
    method: "POST",
    path: "/patients/:patientId/packages",
    summary: "Sell a package definition to a patient: instance + its own invoice, one transaction",
    params: z.object({ patientId: Id }),
    body: SellPackageBody,
    responses: {
      201: PackageSold,
      400: PROBLEMS[400],
      401: PROBLEMS[401],
      403: PROBLEMS[403],
      422: PROBLEMS[422],
    },
  },
  cancel: {
    method: "POST",
    path: "/patient-packages/:patientPackageId/cancel",
    summary: "Front-desk cancellation: the remaining balance burns, history stays",
    params: z.object({ patientPackageId: Id }),
    responses: {
      200: PackageCancelled,
      401: PROBLEMS[401],
      403: PROBLEMS[403],
      404: PROBLEMS[404],
      422: PROBLEMS[422],
    },
  },
});
